/*
  Bundle Gifts controller
  =======================
  Tier- en subscription-aware free gifts voor de bundle-producten. De config
  komt LIVE uit de email-popup app (/api/bundle-config) — dezelfde bron als de
  discount-Function die de gifts gratis maakt. Zo kunnen thema en Function
  nooit uit sync raken.

  Werking:
  1. PDP: bij submit van het product-form worden gift-regels als extra
     items[] meegestuurd (capture-fase, dus vóór product-form.js de FormData
     bouwt). Gifts krijgen property `_bundle_gift`; de Function maakt alleen
     regels met die property gratis (max 1 unit).
  2. Overal: een cart-watcher draait na elke /cart/add|change|update en
     repareert de cart: ontbrekende gifts toevoegen, niet-meer-geldige gifts
     verwijderen, quantity terug naar 1, en — als vangnet — een gift-regel
     die NIET gratis bleek te zijn verwijderen (klant betaalt nooit voor een
     gift).
  3. PDP-strip: toont de gifts van de gekozen tier; subscription-only gifts
     vervagen wanneer de Subscribe & Save-toggle uit staat.

  Eligibility-regels (identiek aan de Function):
  - een tier is gehaald zodra de regel-quantity >= buy + free (= group);
  - tiers stapelen cumulatief (Buy 3 krijgt ook de Buy 2-gifts);
  - `applies` (all | onetime | subscription) wordt getoetst aan de
    bundle-regel, niet aan de gift-regel; gifts zelf zijn altijd one-time.
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('bundle-gifts-config');
  if (!cfgEl) return;
  var SETTINGS;
  try {
    SETTINGS = JSON.parse(cfgEl.textContent);
  } catch (_e) {
    return;
  }
  if (!SETTINGS || !SETTINGS.apiBase || !SETTINGS.shop) return;

  var GIFT_PROP = '_bundle_gift';
  var configCache = null;
  var configPromise = null;
  // Variant-ids van het HUIDIGE product (PDP): nodig om /cart/add-requests van
  // dít product te onderscheiden van upsells/andere forms op dezelfde pagina.
  var currentProductVariants = null;

  function loadCurrentProductVariants() {
    if (!SETTINGS.productId) return;
    try {
      fetch(window.location.pathname + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && String(p.id) === String(SETTINGS.productId) && Array.isArray(p.variants)) {
            currentProductVariants = {};
            p.variants.forEach(function (v) { currentProductVariants[String(v.id)] = true; });
          }
        })
        .catch(function () {});
    } catch (_e) { /* noop */ }
  }
  // Gifts die we verwijderd hebben omdat ze niet gratis bleken (config-drift):
  // deze page-load niet opnieuw toevoegen, anders ontstaat een add/remove-loop.
  var quarantined = {};

  function loadConfig() {
    if (configPromise) return configPromise;
    configPromise = fetch(
      SETTINGS.apiBase + '/api/bundle-config?shop=' + encodeURIComponent(SETTINGS.shop)
    )
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        configCache = j && Array.isArray(j.products) ? j : { products: [] };
        return configCache;
      })
      .catch(function () {
        configCache = { products: [] };
        return configCache;
      });
    return configPromise;
  }

  function appliesMatch(applies, isSub) {
    if (!applies || applies === 'all') return true;
    if (applies === 'onetime') return !isSub;
    if (applies === 'subscription') return isSub;
    return true;
  }

  function productConfig(config, productId) {
    if (!config || !config.products) return null;
    for (var i = 0; i < config.products.length; i++) {
      if (String(config.products[i].id) === String(productId)) return config.products[i];
    }
    return null;
  }

  /**
   * Gifts van alle gehaalde tiers (group <= qty), maar altijd MAX 1 per
   * gift-product — gifts stapelen bewust niet (zelfde gedrag als de e-guide).
   */
  function giftsForQty(productCfg, qty, isSub, includeIneligible) {
    var out = {};
    if (!productCfg) return [];
    (productCfg.tiers || []).forEach(function (t) {
      if (!t || qty < t.group) return;
      (t.gifts || []).forEach(function (g) {
        if (!g || !g.id) return;
        var ok = appliesMatch(g.applies, isSub);
        if (!ok && !includeIneligible) return;
        if (!out[g.id]) out[g.id] = { gift: g, eligible: false, qty: 0 };
        if (ok) { out[g.id].qty = 1; out[g.id].eligible = true; }
      });
    });
    return Object.keys(out).map(function (k) { return out[k]; });
  }

  function isSubActive() {
    var c = window.subscriptionContext;
    return !!(c && c.sellingPlanId);
  }

  function selectedTierQty() {
    var input = document.querySelector('.quantity-break-option.selected input.quantity-break-input');
    if (!input) return 0;
    var v = parseInt(input.value, 10);
    return isNaN(v) ? 0 : v;
  }

  // ---------------------------------------------------------------------------
  // 1) PDP: gift-items PERMANENT in het product-form houden. Niet alleen bij
  //    submit — het thema heeft flows die het form direct serialiseren zonder
  //    submit-event (skip-to-checkout doet `new FormData(form)` + redirect,
  //    en dynamic payment buttons serialiseren ook direct). Een
  //    MutationObserver herstelt de inputs wanneer quantity-break de zijne
  //    herbouwt (tier-wissel).
  // ---------------------------------------------------------------------------
  var syncingForm = false;

  function syncFormGifts() {
    if (syncingForm) return; // observer-loop-guard
    syncingForm = true;
    try {
      var form =
        (typeof Elixir_GetProductForm === 'function' && Elixir_GetProductForm()) ||
        document.querySelector('form[action*="cart/add"].product-buy-form-pdp');
      if (!form) return;

      var existing = form.querySelector('.bundle-gift-items');

      var entries = [];
      if (SETTINGS.productId && configCache) {
        var pc = productConfig(configCache, SETTINGS.productId);
        if (pc) {
          entries = giftsForQty(pc, selectedTierQty(), isSubActive(), false)
            .filter(function (e) { return e.qty > 0; });
        }
      }

      // items[]-indexen scannen buiten onze eigen container om (kit +
      // quantity-break); geen items[]-modus (los product) → watcher-pad.
      var maxIndex = 0;
      var otherItemInputs = 0;
      form.querySelectorAll('input[name^="items["]').forEach(function (inp) {
        if (existing && existing.contains(inp)) return;
        otherItemInputs++;
        var m = inp.name.match(/^items\[(\d+)\]/);
        if (m) maxIndex = Math.max(maxIndex, parseInt(m[1], 10));
      });

      var desired = '';
      if (entries.length && otherItemInputs > 0) {
        desired = JSON.stringify(entries.map(function (e) { return [e.gift.id, e.qty]; })) + '@' + maxIndex;
      }
      var current = existing ? existing.getAttribute('data-signature') || '' : '';
      if (desired === current) return; // al in sync

      if (existing) existing.remove();
      if (!desired) return;

      var wrap = document.createElement('div');
      wrap.className = 'bundle-gift-items';
      wrap.setAttribute('data-signature', desired);
      entries.forEach(function (entry, i) {
        var idx = maxIndex + 1 + i;
        [
          ['items[' + idx + '][id]', String(entry.gift.id)],
          ['items[' + idx + '][quantity]', String(entry.qty)],
          ['items[' + idx + '][properties][' + GIFT_PROP + ']', '1'],
        ].forEach(function (pair) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = pair[0];
          input.value = pair[1];
          wrap.appendChild(input);
        });
      });
      form.appendChild(wrap);
    } catch (_e) {
      /* nooit de PDP breken */
    } finally {
      syncingForm = false;
    }
  }

  // Herbouw wanneer quantity-break/kit het form muteren, met microtask-debounce.
  var formObserver = null;
  function observeForm() {
    var form =
      (typeof Elixir_GetProductForm === 'function' && Elixir_GetProductForm()) ||
      document.querySelector('form[action*="cart/add"].product-buy-form-pdp');
    if (!form || formObserver) return;
    var pending = false;
    formObserver = new MutationObserver(function () {
      if (pending || syncingForm) return;
      pending = true;
      setTimeout(function () { pending = false; syncFormGifts(); }, 30);
    });
    formObserver.observe(form, { childList: true, subtree: true });
  }

  // Vlak vóór een echte submit nog één keer verzekeren (belt & braces).
  document.addEventListener('submit', function (ev) {
    try {
      var form = ev.target;
      if (form && form.matches && form.matches('form[action*="cart/add"]') &&
          !form.classList.contains('free-product-form')) {
        syncFormGifts();
      }
    } catch (_e) { /* noop */ }
  }, true);

  // ---------------------------------------------------------------------------
  // 2) Cart-watcher: na elke cart-mutatie de gift-regels in lijn brengen met
  //    de config. Zelfherstellend in beide richtingen.
  // ---------------------------------------------------------------------------
  var origFetch = window.fetch;
  var syncScheduled = false;
  var syncRunning = false;

  /**
   * KERN VAN DE CHECKOUT-FIX: gifts worden IN de /cart/add-request zelf
   * geïnjecteerd (request-body herschrijven) in plaats van achteraf door de
   * watcher. Alleen zo halen ze flows die direct na de add wegnavigeren
   * (skip-to-checkout, express payment buttons) — de watcher verliest daar de
   * race van de redirect.
   *
   * Veiligheidsregels:
   * - alleen op product-pagina's, en alleen als de toegevoegde variant van HET
   *   HUIDIGE product is (upsells/threshold-gift-forms blijven onaangeroerd);
   * - alleen requests zónder `sections`-param (drawer-flows verwachten een
   *   sections-response; die krijgen hun gift via de watcher);
   * - bij elke parse-onzekerheid: niets herschrijven (watcher = vangnet).
   */
  function rewriteAddBody(init) {
    if (!init || !init.body || !configCache || !SETTINGS.productId || !currentProductVariants) return null;
    var pc = productConfig(configCache, SETTINGS.productId);
    if (!pc) return null;

    // Body → items-lijst normaliseren
    var mainItems = [];
    var body = init.body;
    var entries = null;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      entries = [];
      body.forEach(function (v, k) { entries.push([k, String(v)]); });
    } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      entries = [];
      body.forEach(function (v, k) { entries.push([k, String(v)]); });
    } else if (typeof body === 'string') {
      try {
        var j = JSON.parse(body);
        if (j && Array.isArray(j.items)) {
          mainItems = j.items.map(function (it) { return Object.assign({}, it); });
        } else if (j && j.id) {
          var one = { id: Number(j.id), quantity: Number(j.quantity) || 1 };
          if (j.selling_plan) one.selling_plan = j.selling_plan;
          if (j.properties) one.properties = j.properties;
          mainItems = [one];
        } else return null;
      } catch (_e) {
        try { entries = []; new URLSearchParams(body).forEach(function (v, k) { entries.push([k, String(v)]); }); }
        catch (_e2) { return null; }
      }
    } else return null;

    if (entries) {
      var flat = {}; var props = {}; var hasItemsMode = false;
      entries.forEach(function (pair) {
        var k = pair[0], v = pair[1];
        if (k === 'sections' || k === 'sections_url') { flat.__sections = true; }
        if (/^items\[/.test(k)) hasItemsMode = true;
        var pm = k.match(/^properties\[(.+)\]$/);
        if (pm) { props[pm[1]] = v; return; }
        flat[k] = v;
      });
      if (flat.__sections) return null;        // drawer-flow: niet herschrijven
      if (hasItemsMode) return null;           // items[]-mode (andere theme-variant): watcher-pad
      if (!flat.id) return null;
      var main = { id: Number(flat.id), quantity: parseInt(flat.quantity, 10) || 1 };
      if (flat.selling_plan) main.selling_plan = flat.selling_plan;
      if (Object.keys(props).length) main.properties = props;
      mainItems = [main];
    }
    if (!mainItems.length) return null;

    // Alleen ingrijpen als de add over HET HUIDIGE (bundle-)product gaat, en
    // nooit als er al een gift-regel in de request zit.
    var totalQty = 0; var isSub = false; var touchesCurrent = false;
    for (var i = 0; i < mainItems.length; i++) {
      var it = mainItems[i];
      if (it.properties && it.properties[GIFT_PROP]) return null;
      if (currentProductVariants[String(it.id)]) {
        touchesCurrent = true;
        totalQty += Number(it.quantity) || 1;
        if (it.selling_plan) isSub = true;
      }
    }
    if (!touchesCurrent || totalQty <= 0) return null;

    var gifts = giftsForQty(pc, totalQty, isSub, false).filter(function (e) { return e.qty > 0; });
    if (!gifts.length) return null;

    gifts.forEach(function (entry) {
      var p2 = {}; p2[GIFT_PROP] = '1';
      mainItems.push({ id: Number(entry.gift.id), quantity: entry.qty, properties: p2 });
    });

    var newInit = Object.assign({}, init);
    newInit.body = JSON.stringify({ items: mainItems });
    var headers = new Headers(init.headers || {});
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
    newInit.headers = headers;
    return newInit;
  }

  window.fetch = function (input, init) {
    var url = '';
    try {
      url = String((input && input.url) || input || '');
    } catch (_e) { /* noop */ }
    if (/\/cart\/add(\.js)?($|\?)/.test(url)) {
      try {
        var rewritten = rewriteAddBody(init);
        if (rewritten) init = rewritten;
      } catch (_e) { /* nooit de add breken */ }
    }
    var p = origFetch.call(this, input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { scheduleSync(); }, function () {});
    }
    return p;
  };

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    setTimeout(runSync, 450);
  }

  function cartMutation(path, payload) {
    return origFetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
  }

  async function runSync() {
    syncScheduled = false;
    if (syncRunning) { scheduleSync(); return; }

    /* De drawer van het thema adresseert regels op POSITIENUMMER, niet op key
       (cart.js: parsedState.items[line - 1]). Verwijderen wij hier een regel
       terwijl zijn eigen /cart/change onderweg is, dan verschuift alles eronder
       een plaats op. Hij leest dan een positie die niet meer bestaat, ziet
       undefined, en toont "There was an error while updating your cart".

       De opruimer in cart-drawer.liquid wachtte daar al op; deze niet, en die
       ging 450ms na elke cartmutatie af - precies in het gat. Nu delen ze
       dezelfde stilte. */
    if (Date.now() - (window.__cartUserAction || 0) < 1200) { scheduleSync(); return; }

    syncRunning = true;
    try {
      var config = await loadConfig();
      if (!config.products || !config.products.length) return;

      var cart = await (await origFetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      var items = cart.items || [];

      // Eligibility over de hele cart: elke bundle-regel kan gifts vrijspelen.
      // Altijd max 1 per gift-product — gifts stapelen niet.
      var eligible = {}; // giftId -> { gift, qty }
      items.forEach(function (line) {
        if (line.properties && line.properties[GIFT_PROP]) return;
        var pc = productConfig(config, line.product_id);
        if (!pc) return;
        var isSub = !!line.selling_plan_allocation;
        (pc.tiers || []).forEach(function (t) {
          if (!t || line.quantity < t.group) return;
          (t.gifts || []).forEach(function (g) {
            if (!g || !g.id) return;
            if (appliesMatch(g.applies, isSub)) {
              eligible[g.id] = { gift: g, qty: 1 };
            }
          });
        });
      });

      var present = {};
      var mutated = false;

      /* Alles in een opdracht verzamelen in plaats van een /cart/change.js per
         regel. Elke losse call was een round-trip waar de bezoeker op wachtte,
         en elke call schoof de posities weer op onder de drawer vandaan. */
      var updates = {};

      for (var i = 0; i < items.length; i++) {
        var line = items[i];
        if (!line.properties || !line.properties[GIFT_PROP]) continue;
        var vid = line.variant_id;

        if (!eligible[vid] || quarantined[vid]) {
          // Tier niet (meer) gehaald / purchase-type past niet meer → weg.
          updates[line.key] = 0;
          mutated = true;
          continue;
        }
        if (line.quantity !== eligible[vid].qty) {
          // Gift-regel exact op het vrijgespeelde aantal houden.
          updates[line.key] = eligible[vid].qty;
          mutated = true;
          present[vid] = true;
          continue;
        }
        if (line.final_line_price > 0) {
          // VANGNET: de Function heeft deze regel niet gratis gemaakt
          // (config-drift of discount-conflict). Verwijderen — een klant mag
          // nooit voor een gift betalen. Niet opnieuw toevoegen deze page-load.
          quarantined[vid] = true;
          updates[line.key] = 0;
          mutated = true;
          continue;
        }
        present[vid] = true;
      }

      if (Object.keys(updates).length) {
        await cartMutation('/cart/update.js', { updates: updates });
      }

      // Ontbrekende gifts toevoegen (bv. quantity in de cart opgehoogd tot een
      // hogere tier, of de PDP-injectie is gemist).
      var toAdd = [];
      Object.keys(eligible).forEach(function (vid) {
        if (!present[vid] && !quarantined[vid]) {
          var props = {};
          props[GIFT_PROP] = '1';
          toAdd.push({ id: Number(vid), quantity: eligible[vid].qty, properties: props });
        }
      });
      if (toAdd.length) {
        await cartMutation('/cart/add.js', { items: toAdd });
        mutated = true;
        // Direct her-verifiëren dat de zojuist toegevoegde gifts ook echt
        // gratis zijn (vangnet hierboven vangt ze anders bij de volgende pass).
        scheduleSync();
      }

      if (mutated) refreshDrawer();
    } catch (_e) {
      /* stil falen: nooit de winkel breken */
    } finally {
      syncRunning = false;
    }
  }

  function refreshDrawer() {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !window.cartFunctions || !window.cartFunctions.updateCartDrawer) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      origFetch(root + 'cart?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#CartDrawer');
          if (fresh) window.cartFunctions.updateCartDrawer(drawer, fresh, false, null);
        })
        .catch(function () {});
    } catch (_e) { /* noop */ }
  }

  // ---------------------------------------------------------------------------
  // 3) PDP-weergave: bewust UITGESCHAKELD — gifts worden stil toegevoegd
  //    (merchant-keuze). renderStrip ruimt alleen een eventuele oude strip op.
  // ---------------------------------------------------------------------------
  var STRIP_ID = 'bundle-gifts-strip';

  function renderStrip() {
    var strip = document.getElementById(STRIP_ID);
    if (strip) strip.remove();
  }

  function onStateChange(delay) {
    setTimeout(function () { renderStrip(); syncFormGifts(); }, delay);
  }
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.classList && ev.target.classList.contains('quantity-break-input')) {
      onStateChange(50);
    }
  });
  document.addEventListener('click', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('.quantity-break-option')) {
      onStateChange(100);
    }
  });
  document.addEventListener('subscriptionContext:updated', function () {
    onStateChange(50);
  });

  function init() {
    loadCurrentProductVariants();
    loadConfig().then(function () {
      renderStrip();
      syncFormGifts();
      observeForm();
      // Late timers: quantity-break/subscribe-and-save initialiseren zelf ook
      // vertraagd; nog twee passes zodat de eerste paint altijd klopt.
      onStateChange(600);
      onStateChange(1500);
      // Startup-pass: repareert leftovers (bv. qty in cart gewijzigd op een
      // eerdere pagina, of terug-navigatie met stale cart).
      scheduleSync();
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
